// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandSelector__container___bo56e","title":"BrandSelector__title___u7PlT","searcher":"BrandSelector__searcher___eugA2","brand":"BrandSelector__brand___3kVsH"};